import { useTranslation } from 'react-i18next'

import { Post } from 'lib/_types'
import { logEvent } from 'lib/analytics'
import { ROUTE_PATH } from 'lib/paths'

import Nickname from 'components/Nickname'
import { Link } from 'features/i18n/router'

import './style.scss'

type Props = {
  user: Post['user'] | Post['shared_thread']['last_post']['user']
  isHot?: boolean
  isGroupPost?: boolean
  isGroupOwner?: boolean
  isGroupModerator?: boolean
}

const PostUserName = ({
  user,
  isHot,
  isGroupPost,
  isGroupOwner,
  isGroupModerator,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className="PostUserName">
      <Link
        to={ROUTE_PATH.USER(user?.id)}
        onClick={() => {
          logEvent.user_profile_open({
            target_user_id: user?.id.toString(),
            from: isGroupPost ? 'group_post_user' : 'post_user',
          })
        }}
      >
        <Nickname
          user={user}
          isGroupOwner={isGroupOwner}
          isGroupModerator={isGroupModerator}
        />
      </Link>

      {isHot && <span className="PostUserName__hot">{t('post.hot_post')}</span>}
    </div>
  )
}

export default PostUserName
